<template>
  <select :class="['hz-dropdownlist-default', size]" :name="name">
  </select>
</template>

<script>
  export default {
    name: 'drop-down-list',
    props: {
      name: {
        type: String
      },
      default: {
        default: function () {
          return []
        }
      },
      value: {
        default: function () {
          return ''
        }
      },
      fields: {
        default: function () {
          return {
            'text': 'name',
            'value': 'value'
          }
        }
      },
      size: {
        default: function () {
          return 'hz-dropdownlist-lg'
        }
      },
      label: {
        default: '선택해주세요'
      },
      options: {
        default: function () {
          return []
        }
      },
      dataUrl: {
        type: String,
        default: function () {
          return ''
        }
      },
      readonly: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      auth: {
        type: Boolean,
        default: function () {
          return false
        }
      }
    },
    watch: {
      'value': {
        handler: function (val) {
          const hasUrl = this.dataUrl !== ''
          const hasOptions = this.options.length > 0

          // 선택값 초기화

          if (hasUrl || hasOptions) {
            this.initSelect(val)
          }
        }
      },
      'options': {
        handler: function () {
          // 항목 초기화
          this.refresh()
        }
      },
      'readonly': {
        handler: function (val) {
          // readonly 속성을 설정한다.
          this.setReadonly(val)
        }
      }
    },
    methods: {
      init: function () {
        var data = null
        var element = this.$el
        var vm = this

        // dataSource 초기화
        // URL이 있는 경우에는 REMOTE로 가져온다.
        if (vm.dataUrl !== '') {
          data = {
            transport: {
              read: {
                dataType: 'json',
                url: vm.dataUrl,
                beforeSend: function (req) {
                  // 인증이 필요한 API일 경우, 헤더에 JWT 토큰을 설정해준다.
                  if (vm.auth) {
                    const token = localStorage.getItem('_t')
                    req.setRequestHeader('Authorization', 'JWT ' + token)
                  }
                }
              }
            }
          }
          // 그 외의 경우에는 OPTIONS에 정의된 내용을 사용한다.
        } else {
          data = (typeof this.options === 'function') ? vm.options() : vm.options
        }
        // element 초기화
        $(element).kendoDropDownList({
          dataTextField: this.fields['text'],
          dataValueField: this.fields['value'],
          optionLabel: this.label,
          dataSource: data,
          index: 0,
          change: vm.onChange
        })

        // value 초기화
        if (vm.value !== '') {
          var dropdownlist = $(element).data('kendoDropDownList')
          if (vm.dataUrl !== '') {
            dropdownlist.one('dataBound', function () {
              dropdownlist.value(vm.value)
            })
          } else {
            dropdownlist.value(vm.value)
          }
        }
      },
      initSelect: function (val) {
        const element = this.$el
        const dropdownlist = $(element).data('kendoDropDownList')
        // 셀렉트 값 초기화
        dropdownlist.value(val)
      },
      setReadonly: function (bool) {
        const element = $(this.$el)
        const parentElemnet = element[0].parentNode

        // 드롭다운 리스트에 readonly 속성
        element.data('kendoDropDownList').readonly(bool)

        // parentElemnet
        if (bool) {
          parentElemnet.classList.add('hz-dropdownlist-readonly')
        } else {
          parentElemnet.classList.remove('hz-dropdownlist-readonly')
        }
      },
      refresh: function () {
        const vm = this
        const element = this.$el
        const dropdownlist = $(element).data('kendoDropDownList')
        const options = vm.options

        if (options) {
          // 드롭다운리스트 항목 초기화
          dropdownlist.dataSource.data(options)
          dropdownlist.value(vm.value)
        }
      },
      onChange: function () {
        const element = this.$el
        const dropdownlist = $(element).data('kendoDropDownList')
        const selectedIndex = this.label ? dropdownlist.selectedIndex -1 : dropdownlist.selectedIndex
        const pristineData = dropdownlist.dataSource._pristineData
        const data = pristineData[selectedIndex]

        // Input Event로 데이터를 전달한다.
        this.$emit('input', dropdownlist.value(), data)
      }
    },
    mounted: function () {
      // 초기화
      this.init()
    }
  }
</script>

<style lang="scss">
  .hz-dropdownlist-default {
    width: 100%;

    .k-dropdown-wrap {
      border: 1px solid $border-color;
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.09);
    }

    .k-input, .k-select {
      margin: 0;
      padding: 0;
      border: 0;
      box-shadow: none;
      text-indent: 0;
      color: $hzc-gray-07;
    }
  }

  .k-select .k-icon {
    color: $blue-grey;
  }

  .hz-dropdownlist-lg {
    height: 48px;
    .k-dropdown-wrap {
      height: 46px;
      padding: 0 16px;
    }
    .k-input, .k-select {
      height: 48px;
      line-height: 48px;
    }
  }

  .hz-dropdownlist-md {
    height: 32px;
    .k-dropdown-wrap {
      height: 30px;
      padding: 0 8px;
    }
    .k-input, .k-select {
      height: 32px;
      line-height: 32px;
    }
  }

  .hz-dropdownlist-xs {
    height: 24px;
    .k-dropdown-wrap {
      height: 22px;
      padding: 0 8px;
    }
    .k-input, .k-select {
      height: 24px;
      line-height: 24px;
    }
  }

  .hz-dropdownlist-readonly {
    .k-dropdown-wrap {
      background-color: #eeeeee;
    }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/DropDownList.vue